import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { CatalogPage } from './pages/CatalogPage';
import { ProductPage } from './pages/ProductPage';
import { ContactPage } from './pages/ContactPage';
import { Preloader } from './components/Preloader';
import { PartnerPage } from './pages/PartnerPage';
import { CookieConsent } from './components/CookieConsent';
import { AdminPage } from './pages/AdminPage';
import { LanguageProvider } from './utils/i18n';
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AppLayout() {
  const {
    pathname
  } = useLocation();
  const isAdmin = pathname === '/admin';
  return <div className="min-h-screen bg-white flex flex-col font-sans" data-id="element-0">
      {!isAdmin && <Header data-id="element-1" />}
      <main className="flex-grow" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/catalog" element={<CatalogPage data-id="element-7" />} data-id="element-6" />
          <Route path="/catalog/:productId" element={<ProductPage data-id="element-9" />} data-id="element-8" />
          <Route path="/contact" element={<ContactPage data-id="element-11" />} data-id="element-10" />
          <Route path="/partner" element={<PartnerPage data-id="element-13" />} data-id="element-12" />
          <Route path="/admin" element={<AdminPage data-id="element-15" />} data-id="element-14" />
        </Routes>
      </main>
      {!isAdmin && <Footer data-id="element-16" />}
    </div>;
}
export function App() {
  const [showPreloader, setShowPreloader] = useState(true);
  return <LanguageProvider data-id="element-17">
      {showPreloader && <Preloader onComplete={() => setShowPreloader(false)} data-id="element-18" />}
      <Router data-id="element-19">
        <ScrollToTop data-id="element-20" />
        <AppLayout data-id="element-21" />
        <CookieConsent data-id="element-22" />
      </Router>
    </LanguageProvider>;
}